import { ProjectCashCurveBase } from './base/project-cash-curve-base';

export class ProjectCashCurve extends ProjectCashCurveBase { }